<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="submission">
            <van-nav-bar
                left-arrow
                right-text="提交"
                v-if="isNews != true"
                :title="title"
                :left-text="leftText"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="onClickLeft"
                @click-right="submission"
            >
            </van-nav-bar>
            <section>
                <div class="linkNode" v-if="submissionMethod != 'role' && submissionMethod !== 'personnel'">
                    <h4>
                        <span class="iconfont sm-bumen">
                            选择节点
                        </span>
                        <div>
                            <button v-if="nodeState" @click="nodeState = false">
                                展开
                                <i class="iconfont sm-down"></i>
                            </button>
                            <button v-else @click="nodeState = true">
                                收起
                                <i class="iconfont sm-up"></i>
                            </button>
                        </div>
                    </h4>
                    <ul v-if="!nodeState">
                        <li
                            v-for="(item, index) in nodeData"
                            :class="{'active': currentNode == index, 'countersignatureNode': item.node_type == 3}"
                            :key="index"
                            @click="selectNode(index, item, 'node')"
                        >
                            <span v-if="item.node_type == 3">会签审核</span>
                            <span v-else>{{ item.data[0].BusinessPhaseName }}</span>
                            <i class="iconfont sm-duigou"></i>
                        </li>
                    </ul>
                    <ol v-if="countersignNodeData.length > 0">
                        <li
                            v-for="(item, index) in countersignNodeData"
                            :key="index"
                            :class="{'active': currentCountersignatureNode === index}"
                            @click="selectNode(index, item, 'childNode')"
                        >
                            <div class="nodeNmame">
                                <i v-if="item.IsRequired == 1">*</i>
                                {{ item.BusinessPhaseName }}
                            </div>
                            <div class="noedeUser">
                                已选：
                                <span v-for="(k, i) in item.ApproverName" :key="i">{{ k }}</span>
                            </div>
                        </li>
                        <!-- <li class="btns">
                            <span>展开</span>
                            <i class="iconfont sm-shuangjiantouxia"></i>
                        </li> -->
                    </ol>
                </div>
                <div class="personnelList" v-if="!isCrossHierarchy && nodeApproverCategory == 2 && !isBack || submissionMethod === 'role' || submissionMethod === 'personnel'">
                    <div class="role" v-if="submissionMethod !== 'personnel'">
                        <h5 class="iconfont sm-05qunzufill">
                            角色
                        </h5>
                        <van-sidebar v-model="activeKey">
                            <van-sidebar-item v-for="(item, index) in approverRoleName" :key="index" :title="item" @click="obtainPersonnel(index)"></van-sidebar-item>
                        </van-sidebar>
                    </div>
                    <div class="member" :class="{'member-full': submissionMethod === 'personnel'}">
                        <h5 class="iconfont sm-04gerenfill">
                            成员
                        </h5>
                        <van-index-bar :index-list="indexList" :sticky="false">
                            <div v-for="(item, index) in waitMembersData" :key="index">
                                <van-index-anchor :index="item.Initial"></van-index-anchor>
                                <template v-if="isRadio">
                                    <van-radio-group v-model="radioChosedMembers" @change="handleCheckedWaitChange(item.data)">
                                        <van-radio v-for="(k, i) in item.data" :key="i" :name="k.user_id" checked-color="#ee0a24">
                                            {{ k.user_name }}
                                        </van-radio>
                                    </van-radio-group>
                                </template>
                                <template v-else>
                                    <van-checkbox-group v-model="result">
                                        <van-checkbox v-for="(k, i) in item.data" :key="i" v-model="checked">
                                            {{ k.user_name }}
                                        </van-checkbox>
                                    </van-checkbox-group>
                                </template>
                            </div>
                        </van-index-bar>
                    </div>
                </div>
                <div class="personnelIdentified" v-else>
                    <ul v-if="approverRoleName.length > 0">
                        <li v-for="(item, index) in approverRoleName" :key="index">
                            <span class="state iconfont sm-jiaobiao"><i>已选</i></span>
                            <div class="headPortrait van_left">
                                <!-- <img src="@/assets/images/addressBook/b_head_portrait_man@2x.png" alt=""> -->
                            </div>
                            <div class="info van_left">
                                <h5>{{ item }}</h5>
                                <!-- <p>销售主管</p> -->
                            </div>
                        </li>
                    </ul>
                </div>
                <van-dialog
                    v-model="confirmedByShow"
                    title="提交确认"
                    show-cancel-button
                    @cancel="cancelSubmission"
                    @confirm="confirmSubmission"
                    class="submitPopUp"
                >
                    <div class="submitPopUpContent">
                        <div class="icon">
                            <img src="@/assets/images/contractApproval/icon.png" alt="">
                        </div>
                        <div class="info" v-if="submissionMethod === 'role'">
                            <h4 v-if="NextApproverNames !=''">
                                已选审批人：
                                <span>
                                    {{ NextApproverNames }}
                                </span>
                            </h4>
                            <p>是否确认提交？</p>
                        </div>
                        <div class="info linkInfo" v-else>
                            <h4 v-if="currentNodeName !=''">
                                下一环节：
                                <span>
                                    {{ currentNodeName }}
                                </span>
                            </h4>
                            <h4 v-if="NextApproverNames !=''">
                                审批人：
                                <span>
                                    {{ NextApproverNames }}
                                </span>
                            </h4>
                            <p>是否确认提交？</p>
                        </div>
                    </div>
                </van-dialog>
            </section>
            <div class="btns" v-if="isNews">
                <van-button block type="primary" color="linear-gradient(to right, #ff6034, #ee0a24)" @click="submission">
                    提交
                </van-button>
            </div>
        </div>
    </v-touch>
</template>
<script>

export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            // 父页面传递数据
            parentData: {},
            // 页面标题
            title: '',
            leftText: '',
            // 当前打开角色下标
            activeKey: 0,
            // 审批数据
            // approvalData: {},
            // 提交方式
            submissionMethod: '',
            // 流程数据（自由提交提交）
            processData: {},
            // 当前环节标识（自由提交提交）
            businessPhaseId: '',
            // 环节数据集合
            nodeData: [],
            // 当前选择环节下标
            currentNode: 0,
            // 当前选择环节数据
            currentNodeData: {},
            // 当前环节id
            currentNodeId: '',
            // 当前环节类型
            nodeType: 0,
            // 当前选择环节名称
            currentNodeName: '',
            // 会签节点数据
            countersignNodeData: [],
            // 会签节点选中下标
            currentCountersignatureNode: 0,
            // 当前环节审批人类别
            nodeApproverCategory: 0,
            // 是否允许修改办理人
            isAllowEditApprover: false,
            // 是否是跨级审批
            isCrossHierarchy: false,
            // 环节审批角色id
            approverRoleId: [],
            // 环节审批角色name
            approverRoleName: [],
            // 是否单选
            isRadio: true,
            // 角色下所有人员
            allWaitingMemberData: [],
            // 角色下人员
            waitMembersData: [],
            // 索引数组
            indexList: [],
            // 已选-单选
            radioChosedMembers: '',
            // 下一环节审批人id集合
            NextApproverIds: '',
            // 下一环节审批人name集合
            NextApproverNames: '',
            // 确认人员弹出层状态
            confirmedByShow: false,
            // 是否只读
            isReadOnly: true,
            // 人员提交数据
            ApiData: {},
            // 流程id
            BusinessInstanceId: '',
            // 是否是消息跳转审批
            isNews: false,
            // 节点状态（true收起，fal展开）
            nodeState: false,
            // 退回
            isBack: null,
            newsToken: '',
            // 人员是否按部门过滤
            isDeptFilter: false,
            // 部门类型
            deptFilterType: '',

            // 是否填写意见
            isOpinion: false,
            // 是否需要填写意见
            isFillOpinion: true,
            // 是否需要填写意见[退回]
            isFillOpinion_return: true,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.parentData = this.$route.params.data;
        this.isNews = this.$route.params.isNews;
        this.newsToken = this.$route.params.thisToken;
        this.isOpinion = this.$route.params.isOpinion;
        this.isFillOpinion = this.$route.params.isFillOpinion;
        this.isFillOpinion_return = this.$route.params.isFillOpinion_return;

        this.title = this.parentData.title;
        this.leftText = this.parentData.leftText ? this.parentData.leftText : '审批办理';
        this.submissionMethod = this.parentData.type;
        // 读取父页面流程数据
        this.processData = JSON.parse(JSON.stringify(this.parentData.processData));
        // 人员是否按部门过滤
        this.isDeptFilter = this.processData.CurrentBusinessProcess?.SubmitPhaseModel?.IsDeptFilter;
        // 部门类型
        this.deptFilterType = this.processData.CurrentBusinessProcess?.SubmitPhaseModel?.DeptFilterType;
        // 流程id
        this.BusinessInstanceId = this.processData.BusinessInstanceInfo.BusinessInstanceId;
        // type等于role普通提交，link自由提交(只能选当前环节后面环节)，linkBtn自由提交（可以选择所有环节）
        if (this.submissionMethod === 'role') {
            if (this.processData.CurrentBusinessProcess.SubmitPhaseModel) {
                this.approverRoleId = this.processData.CurrentBusinessProcess.SubmitPhaseModel.ApproverRoleId.split(',');
                this.approverRoleName = this.processData.CurrentBusinessProcess.SubmitPhaseModel.ApproverRoleName.split(',');
            }
            // 初始化第一个角色数据
            this.obtainPersonnel(0);
        } else if (this.submissionMethod === 'personnel') {
            // 审批人类型99，直接使用父页面传入的待选人员列表，无需再请求接口
            this.currentNodeName = this.parentData.phaseName || '';
            this.obtainPersonnelByList(this.parentData.personnelList || []);
        } else if (this.submissionMethod === 'countersign') {
            // 当前选择环节名称
            this.currentNodeName = '会签审核';
            if (this.processData.CurrentBusinessProcess.SubmitPhaseNodes) {
                this.processingLinkData(this.processData.CurrentBusinessProcess.SubmitPhaseNodes);
            }
            // 初始化第一个角色数据
            this.obtainPersonnel(0);
        } else if (['link', 'customSubmit', 'customReturn'].indexOf(this.submissionMethod) > -1) {
            this.businessPhaseId = this.processData.CurrentBusinessProcess.BusinessPhaseId;
            // 获取节点数据
            this.gitNodeData(this.submissionMethod).then(() => {
                // 初始化第一个角色数据
                if (['link'].includes(this.submissionMethod)) {
                    this.obtainPersonnel(0);
                }
            });
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取节点数据
        async gitNodeData(type) {
            let getUrl = '';
            if (type === 'customReturn') {
                getUrl = `/interfaceApi/basicplatform/simpleflow/processes/phases/before/${this.businessPhaseId}`;
            } else {
                getUrl = `/interfaceApi/basicplatform/simpleflow/processes/phases/new/${this.businessPhaseId}`;
            }
            const res = await this.gitNodeDataRequest(getUrl);
            this.processingLinkData(res);
        },
        // 处理环节数据
        processingLinkData(res) {
            const newData = res;
            newData.forEach(k => {
                k.data.forEach(item => {
                    // 审批人id
                    if (item.ApproverId) {
                        item.ApproverId = item.ApproverId.split(',');
                    } else {
                        item.ApproverId = [];
                    }
                    // 审批人name
                    if (item.ApproverName) {
                        item.ApproverName = item.ApproverName.split(',');
                    } else {
                        item.ApproverName = [];
                    }
                    // 审批角色id
                    if (item.ApproverRoleId) {
                        item.ApproverRoleId = item.ApproverRoleId.split(',');
                    } else {
                        item.ApproverRoleId = [];
                    }
                    // 审批角色name
                    if (item.ApproverRoleName) {
                        item.ApproverRoleName = item.ApproverRoleName.split(',');
                    } else {
                        item.ApproverRoleName = [];
                    }
                });
            });
            // 环节数据
            this.nodeData = newData;
            // 环节类型
            this.nodeType = this.nodeData[0].node_type;
            const row = this.nodeData[0].data[0];
            // 是否是退回
            this.isBack = this.nodeData[0].is_back;
            // 当前环节审批人类别
            this.nodeApproverCategory = row.ApproverType;
            // 当前环节id
            this.currentNodeId = row.BusinessPhaseId;
            // 当前环节数据
            this.currentNodeData = row;
            // 是否允许修改办理人;
            this.isAllowEditApprover = row.IsAllowEditApprover;
            let user_id = [];
            let user_name = [];
            if (this.nodeType === 3) {
                // 会签节点数据
                this.countersignNodeData = newData[0].data;
                this.currentCountersignatureNode = 0;
                this.nodeData[0].data.forEach(k => {
                    if (k.ApproverId && k.ApproverId.length > 0) {
                        user_id.push(...k.ApproverId.toString());
                    }
                    if (k.ApproverName && k.ApproverName.length > 0) {
                        user_name.push(...k.ApproverName.toString());
                    }
                });
            } else {
                this.countersignNodeData = [];
                if (row.ApproverId && row.ApproverId.length > 0) {
                    user_id = row.ApproverId[0].toString();
                }
                if (row.ApproverName && row.ApproverName.length > 0) {
                    user_name = row.ApproverName[0].toString();
                }
            }

            this.isCrossHierarchy = newData[0].IsCrossHierarchy;
            if (this.isCrossHierarchy !== true) {
                // 过滤审批人类别数据
                if (this.isBack) {
                    this.filterData_back(row);
                } else {
                    this.filterData(row);
                }
            }
        },
        // 过滤审批人类别数据
        filterData(data) {
            if (this.nodeApproverCategory === 1) {
                // 默认第一个环节id赋值
                if (data.ApproverId) {
                    this.approverRoleId.push(...data.ApproverId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverName) {
                    this.approverRoleName.push(...data.ApproverName);
                }
            } else if (this.nodeApproverCategory === 2) {
                // 默认第一个环节id赋值
                if (data.ApproverRoleId) {
                    this.approverRoleId.push(...data.ApproverRoleId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverRoleName) {
                    this.approverRoleName.push(...data.ApproverRoleName);
                }
                // 默认拉取第一个角色下人员
                this.obtainPersonnel(0, data);
            }
        },
        // 过滤审批人类别数据-已审环节[自由提交选择已提交环节]
        filterData_back(data) {
            if (data.HandledUsers?.length > 0) {
                const row = data.HandledUsers[data.HandledUsers.length - 1];
                this.approverRoleId.push(row.ApproverId);
                this.approverRoleName.push(row.ApproverName);
            } else if (this.nodeApproverCategory === 1) {
                this.approverRoleId.push(...data.ApproverId);
                this.approverRoleName.push(...data.ApproverName);
                this.loading = false;
            } else if (this.nodeApproverCategory === 2) {
                // 默认第一个环节id赋值
                if (data.ApproverRoleId) {
                    this.approverRoleId.push(...data.ApproverRoleId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverRoleName) {
                    this.approverRoleName.push(...data.ApproverRoleName);
                }
                // 默认拉取第一个角色下人员
                this.obtainPersonnel(0, data);
            }
        },
        // 获取角色下人员
        async obtainPersonnel(index, row) {
            const roleid = this.approverRoleId[index];
            let orgtype = '';
            if (this.isDeptFilter) {
                orgtype = this.deptFilterType;
            }
            const res = await this.obtainPersonnelRequest(roleid, orgtype);
            this.allWaitingMemberData = JSON.parse(JSON.stringify(res));
            // 处理数据
            const newData = this.$dataSorting(res, 'user_name');
            // 角色下人员数据赋值
            this.waitMembersData = newData.dataList;
            // 索引数组赋值
            this.indexList = newData.indexList;

            if (row && (row.ApproverId || []).length > 0) {
                this.radioChosedMembers = row.ApproverId[0];
            } else {
                this.radioChosedMembers = '';
            }
        },
        // 使用父页面传入的待选人员列表（审批人类型99），无需请求接口
        obtainPersonnelByList(list) {
            this.isRadio = true;
            this.allWaitingMemberData = JSON.parse(JSON.stringify(list));
            const newData = this.$dataSorting(list, 'user_name');
            this.waitMembersData = newData.dataList;
            this.indexList = newData.indexList;
        },
        // 选择节点
        selectNode(index, row, type) {
            // 环节审批角色name
            this.approverRoleName = [];
            // 角色下人员
            this.waitMembersData = [];

            this.approverRoleId = [];
            this.NextApproverIds = '';
            this.NextApproverNames = '';

            if (type === 'node') {
                // 当前选择环节下标
                this.currentNode = index;
                // 当前环节类型
                this.nodeType = row.node_type;
                // 当前选择环节数据
                this.currentNodeData = row.data[0];
                // 是否是退回
                this.isBack = row.is_back;
                if (row.node_type === 3) {
                    // 当前选择环节名称
                    this.currentNodeName = '会签审核';
                    this.countersignNodeData = row.data;
                    this.currentCountersignatureNode = 0;
                } else {
                    this.countersignNodeData = [];
                    // 当前选择环节名称
                    this.currentNodeName = this.currentNodeData.BusinessPhaseName;
                }
            } else {
                this.currentCountersignatureNode = index;
                this.currentNodeData = row;
            }

            // 当前环节审批人类别
            this.nodeApproverCategory = this.currentNodeData.ApproverType;
            // 当前环节id
            this.currentNodeId = this.currentNodeData.BusinessPhaseId;
            // 是否允许修改办理人;
            this.isAllowEditApprover = this.currentNodeData.IsAllowEditApprover;
            // 是否是跨级审批
            this.isCrossHierarchy = this.currentNodeData.IsCrossHierarchy;
            if (this.isCrossHierarchy !== true) {
                // 过滤审批人类别数据
                if (this.isBack) {
                    this.filterData_back(this.currentNodeData);
                } else {
                    this.filterData(this.currentNodeData);
                }
            }
        },
        // 选择成员
        handleCheckedWaitChange() {
            this.currentNodeData.ApproverId = [];
            this.currentNodeData.ApproverName = [];
            this.allWaitingMemberData.forEach(item => {
                if (item.user_id === this.radioChosedMembers) {
                    if (this.isRadio) {
                        this.currentNodeData.ApproverId.push(item.user_id);
                        this.currentNodeData.ApproverName.push(item.user_name);
                    }
                }
            });
        },
        // 提交
        // eslint-disable-next-line complexity
        submission() {
            this.ApiData = {};
            const idS = [];
            const nameS = [];
            let new_transferMode = null;
            if (this.isBack) { // 提交已审批环节，退回状态
                new_transferMode = 21;
                if (this.isFillOpinion_return && !this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            } else {
                new_transferMode = 10;
                if (this.isFillOpinion && !this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            if (this.submissionMethod === 'role' || this.submissionMethod === 'personnel') {
                if ((this.currentNodeData?.ApproverId || []).length > 0) {
                    idS.push(...this.currentNodeData?.ApproverId);
                    nameS.push(...this.currentNodeData?.ApproverName);
                }
            } else if (this.nodeData[this.currentNode].is_back) {
                this.nodeData[this.currentNode].data.forEach(k => {
                    const row = k.HandledUsers[k.HandledUsers.length - 1];
                    if (row) {
                        idS.push(row.ApproverId);
                        nameS.push(row.ApproverName);
                    }
                });
            } else {
                this.nodeData[this.currentNode].data.forEach(k => {
                    if (k.ApproverId) {
                        idS.push(...k.ApproverId);
                    }
                    if (k.ApproverName) {
                        nameS.push(...k.ApproverName);
                    }
                });
            }
            this.NextApproverIds = idS.toString();
            this.NextApproverNames = nameS.toString();

            // 判断是否有下一环节审批人id集合和下一环节审批人name集合，有值进行提交
            if (this.NextApproverIds !== '' || this.NextApproverNames !== '' || this.isCrossHierarchy === true) {
                if (this.submissionMethod === 'role' || this.submissionMethod === 'personnel') {
                    this.ApiData = {
                        BusinessInstanceId: this.BusinessInstanceId,
                        CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                        TransferMode: new_transferMode,
                        NextApproverIds: this.NextApproverIds,
                        NextApproverNames: this.NextApproverNames,
                    };
                } if (this.submissionMethod === 'countersign') { // 会签节点提交
                    const currentlySelectedNodeData = [];
                    this.nodeData[this.currentNode].data.forEach(item => {
                        currentlySelectedNodeData.push({
                            NextPhsaeId: item.BusinessPhaseId,
                            NextApproverIds: item.ApproverId.toString(),
                            NextApproverNames: item.ApproverName.toString(),
                        });
                    });
                    this.ApiData = {
                        BusinessInstanceId: this.BusinessInstanceId,
                        CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                        TransferMode: new_transferMode,
                        NextPhsaeId: '',
                        NextApproverIds: '',
                        NextApproverNames: '',
                        MultiPhase: currentlySelectedNodeData,
                    };
                } else if (this.submissionMethod === 'link') { // 提交按钮提交，提交环节是自由提交环节类型
                    if (this.nodeApproverCategory === 1) {
                        // 跨级审批
                        this.ApiData = {
                            BusinessInstanceId: this.BusinessInstanceId,
                            CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                            TransferMode: new_transferMode,
                            NextPhsaeId: this.currentNodeId,
                            NextApproverIds: this.NextApproverIds,
                            NextApproverNames: this.NextApproverNames,
                        };
                    } else if (this.nodeApproverCategory === 2) {
                        if (this.isAllowEditApprover) {
                            this.ApiData = {
                                BusinessInstanceId: this.BusinessInstanceId,
                                CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                                TransferMode: new_transferMode,
                                NextPhsaeId: this.currentNodeId,
                                NextApproverIds: this.NextApproverIds,
                                NextApproverNames: this.NextApproverNames,
                            };
                        } else {
                            this.ApiData = {
                                BusinessInstanceId: this.BusinessInstanceId,
                                CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                                TransferMode: new_transferMode,
                                NextPhsaeId: this.currentNodeId,
                                NextApproverIds: null,
                                NextApproverNames: null,
                            };
                        }
                    }
                } else if (['customSubmit', 'customReturn'].includes(this.submissionMethod)) { // 自由提交按钮提交
                    if (this.nodeType === 3) {
                        const currentlySelectedNodeData = [];
                        const row = JSON.parse(JSON.stringify(this.countersignNodeData));
                        row.forEach(item => {
                            if (item.ApproverId) {
                                item.ApproverId = item.ApproverId.toString();
                            }
                            // 审批人name
                            if (item.ApproverName) {
                                item.ApproverName = item.ApproverName.toString();
                            }
                            // 审批角色id
                            if (item.ApproverRoleId) {
                                item.ApproverRoleId = item.ApproverRoleId.toString();
                            }
                            // 审批角色name
                            if (item.ApproverRoleName) {
                                item.ApproverRoleName = item.ApproverRoleName.toString();
                            }
                            currentlySelectedNodeData.push({
                                NextPhsaeId: item.BusinessPhaseId,
                                NextApproverIds: item.ApproverId,
                                NextApproverNames: item.ApproverName,
                            });
                        });

                        this.ApiData = {
                            BusinessInstanceId: this.BusinessInstanceId,
                            CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                            TransferMode: new_transferMode,
                            NextPhsaeId: this.currentNodeId,
                            NextApproverIds: null,
                            NextApproverNames: null,
                            MultiPhase: currentlySelectedNodeData,
                        };
                    } else {
                        this.ApiData = {
                            BusinessInstanceId: this.BusinessInstanceId,
                            CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                            TransferMode: new_transferMode,
                            NextPhsaeId: this.currentNodeId,
                            NextApproverIds: this.NextApproverIds,
                            NextApproverNames: this.NextApproverNames,
                        };
                    }
                }
                this.confirmedByShow = true;
            } else {
                this.$toast('请先选择人员！');
            }
        },
        // 取消提交
        cancelSubmission() {
            this.NextApproverIds = '';
            this.NextApproverNames = '';
            this.radioChosedMembers = '';
            this.$toast('已取消！');
        },
        // 确认提交
        confirmSubmission() {
            this.submitAPI(this.ApiData);
        },
        // 流程提交
        async submitAPI(data) {
            this.$toast.loading({ overlay: true, duration: 0 });
            await this.submitAPIRequest(data);
            this.$toast.success('提交成功！');
            this.NextApproverIds = '';
            this.NextApproverNames = '';
            this.radioChosedMembers = '';
            this.$toast.clear();
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.$route.params.backPathName,
                params: {
                    isRefresh: true,
                },
            });
            if (this.isNews !== true) {
                this.$store.commit('noKeepAlive', 'approval-process');
            }
        },


        // 获取节点数据请求
        gitNodeDataRequest(getUrl) {
            return this.$axios.$get(getUrl, { token: this.newsToken });
        },

        // 获取角色下人员请求
        obtainPersonnelRequest(roleid, orgtype) {
            const url = `/interfaceApi/basicplatform/simpleflow/processes/getphaseroleuser?roleId=${roleid}&orgtype=${orgtype}`;
            return this.$axios.$get(url, { token: this.newsToken });
        },

        // 流程提交请求
        submitAPIRequest(data) {
            return this.$axios.$post('/interfaceApi/basicplatform/simpleflow/processes', data, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.submission
    height 100%
    section
        height calc(100% - 45rpx)
        overflow auto
        position relative
        .linkNode
            padding 10rpx 10rpx 5rpx
            border-bottom 2px solid #F0F0F0
            h4
                font-size 16rpx
                color #3575AF
                margin-bottom 15rpx
                display flex
                justify-content space-between
                div
                    button
                        height 20rpx
                        padding 0 8rpx
                        font-size 12rpx
                        color #666666
                        background #F0F0F0
                        border none
                        border-radius 5rpx
                        i
                            font-size 12rpx
            ul
                display flex
                flex-wrap wrap
                li
                    overflow hidden
                    border-radius 4px
                    border 1px solid #D7D7D7
                    font-size 14rpx
                    line-height 30rpx
                    margin 0 7rpx
                    text-align center
                    position relative
                    padding 0 7rpx
                    margin-bottom 10rpx
                    i
                        position absolute
                        top 14rpx
                        right -20rpx
                        border-radius 50%
                        width 40rpx
                        height 40rpx
                        background #0189FC
                        display none
                        &:before
                            position absolute
                            top -5rpx
                            left 6rpx
                            font-size 12rpx
                    &.active
                        border none
                        color #fff
                        background-image: linear-gradient(to right, #3A96FE , #40B6FF);
                        i
                            display block
                    &.countersignatureNode
                        position relative
                        padding 0 12rpx
                        &:after
                            content ''
                            width 20rpx
                            height 20rpx
                            position absolute
                            top 0
                            left 0
                            background url(images/icon1_normal.png) no-repeat
                            background-size 100% 100%
                        &.active
                            &:after
                                background url(images/icon1_highlight.png) no-repeat
                                background-size 100% 100%
                        i
                            display none
            ol
                display flex
                flex-wrap wrap
                border 1px solid #D7D7D7
                border-radius 3px
                padding 7rpx 7rpx 0 7rpx
                li
                    min-width calc(100%/3 - 14rpx)
                    margin 7rpx
                    div
                        height 30rpx
                        line-height 30rpx
                        color #694016
                    .nodeNmame
                        position relative
                        font-size 14rpx
                        text-align center
                        border 1px solid #EFE4D1
                        border-radius 4px 4px 0 0
                        &:after
                            content ''
                            width 20rpx
                            height 20rpx
                            position absolute
                            top 0
                            left 0
                            background url(images/icon2_normal.png) no-repeat
                            background-size 100% 100%
                        i
                            font-size 0.2rem
                            color red
                    .noedeUser
                        padding 0 8rpx
                        font-size 12rpx
                        border 1px dashed #EFE4D1
                        border-top none
                        border-radius 0 0 4px 4px
                    &.btns
                        width 100%
                        line-height 26rpx
                        height 26rpx
                        text-align center
                        font-size 12rpx
                        color #666666
                        vertical-align middle
                    &.active
                        box-shadow 3rpx 3rpx 6rpx rgba(0, 73, 156, 0.3)
                        div
                            color #048AFC
                            border-color #3B99FE
                        .nodeNmame
                            &:after
                                background url(images/icon2_highlight.png) no-repeat
                                background-size 100% 100%
        .personnelList
            width 100%
            overflow hidden
            display flex
            min-height 100%
            .role,.member
                h5
                    font-size 16rpx
                    color #eb0002
                    line-height 45rpx
                    padding-left 15rpx
                    border-bottom 1px solid #F0F0F0
            .role
                width 110rpx
                background #F4F7FD
                .van-sidebar
                    width 100%
                    .van-sidebar-item
                        padding 0
                        font-size 14rpx
                        line-height 16rpx
                        padding 13rpx 8rpx
                        text-align center
                        background none
                        &.van-sidebar-item--select
                            background #fff
                            color #EB6348
            .member
                width calc(100% - 110rpx)
                padding-bottom 30rpx
                &.member-full
                    width 100%
                .van-index-bar
                    position relative
                    .van-index-bar__sidebar
                        position absolute
                        background #fff
                        height 100%
                        padding-top 10rpx
                        z-index 0
                        span
                            line-height 24rpx
                            padding 0 4rpx
                .van-index-anchor
                    font-size 12rpx
                    line-height 20rpx
                    background #F9F9F9
                .van-radio-group
                    .van-radio
                        font-size 16rpx
                        line-height 45rpx
                        height 45rpx
                        color #333333
                        padding-left 15rpx
                        border-bottom 1px solid #F0F0F0
                        .van-radio__label
                            margin-left 15rpx
        .personnelIdentified
            width 100%
            overflow hidden
            ul
                height 100%
                background #F0F0F0
                padding 15rpx
                li
                    height 72rpx
                    padding 15rpx
                    background #fff
                    position relative
                    box-shadow 0 2px 8px rgba(52, 149, 251, 0.5)
                    .state
                        position absolute
                        top 0
                        right 0
                        font-weight 400
                        width 40rpx
                        height 40rpx
                        &:before
                            font-size 40rpx
                            line-height 40rpx
                            color #E60000
                            position absolute
                            top 0px
                            right 0
                        i
                            position absolute
                            width 40rpx
                            text-align center
                            font-size 12rpx
                            color #FFFFFF
                            transform rotate(45deg)
                            top 7rpx
                            left 7rpx
                    .headPortrait
                        width 42rpx
                        height 42rpx
                        margin-right 15rpx
                        img
                            width 100%
                            height 100%
                    .info
                        h5
                            font-size 16rpx
                            color #333333
                            line-height 42rpx
                        p
                            font-size 14rpx
                            color #979EA7
        .submitPopUp
            .van-dialog__header
                padding-top none
                line-height 50rpx
            .van-dialog__content
                padding 15rpx 0
                border-top 2px solid #F0F0F0
                text-align center
                .icon,.info
                    display inline-block
                    vertical-align top
                .icon
                    width 94rpx
                    height 84rpx
                    img
                        height 100%
                .info
                    text-align left
                    margin-top 10rpx
                    h4
                        line-height 20rpx
                        font-size 14rpx
                        color #666666
                        margin-bottom 20rpx
                        span
                            font-size 18rpx
                            color #3495FB
                    p
                        font-size 14rpx
                        color #979EA7
                    &.linkInfo
                        margin-top 5rpx
                        h4
                            margin-bottom 10rpx
    .btns
        height 45rpx
        button
            height 45rpx
            line-height 45rpx
            font-size 16rpx
</style>
